export const dashboard = {
  getUserDetails: 'user',
  getMenuList: 'menu',
  configuration: 'configs',
  getNotification:'notification/notificationDetails',
  readNotification:'notification/notificationRead',
  getNotificationStatus: 'notification/notificationStatus',
  allRead: 'notification/notificationMarkAllAsRead ',
  featureApi : 'rolesPermission',
  getApiKeys: 'common/getApiKeys'
}

export const scenario = {
  getScenerioList: 'planner/scenarios',
  getApprovalScenerioList: 'planner/approvedScenario',
  dateConfiguaration: '/configs',
  statuslist: 'planner/status',
  scenarioDelete: 'planner/scenario',
  creatorData: 'planner/users',
  priceTier: 'planner/priceTiers',
  skuDetails: 'planner/skuDetails',
  getApprovedScenariopriceBand: 'planner/approvedScenarioPriceBand',
  getApprovedScenarioskuDetails: 'planner/approvedScenarioSKUDetails',
  getApprovedScenarioskuDetailsCount: 'planner/approvedScenarioSKUDetailsCount',
  createSkuDetails: 'planner/saveScenarioDetails',
  scenarioHeader: 'planner/info',
  createScenarioHeader: 'planner/createScenarioInfo',
  estimatedImpact: 'planner/estimatedImpact',
  estimatedImpactPriceBand: 'planner/estimatedImpactPriceBand',
  estimatedImpactPriceBandOverall: 'planner/estimatedImpactPriceBandOverall',
  originalImpact: 'planner/originalImpact',
  originalImpactPriceBand: 'planner/originalImpactPriceBand',
  originalImpactPriceBandOverall: 'planner/originalImpactPriceBandOverall',
  priceTierDropdown: 'planner/priceTierDropdown',
  category: 'planner/skuCategory',
  skuDetailsCount: 'planner/skuDetailsCount',
  recalculateImpact: 'planner/recalculateImpact',
  createScenario: 'planner/createScenario',
  download: 'planner/download',
  upload: 'planner/upload',
  submitForRejected: 'planner/submitForRejected',
  submitForApproved: 'planner/submitForApproved',
  submitForApproval: 'planner/submitForApproval',
  tempAPis: {
    estimatedImpactPriceBandOverall: 'planner/estimatedImpactPriceBandOverallTemp',
    skuDetailsCount: 'planner/skuDetailsCountTemp',
    skuDetails: 'planner/skuDetailsTemp',
    l1Category: 'planner/getTempCategoryLvl1',
    l2Category: 'planner/getTempCategoryLvl2',
    subCategory:'planner/getTempSubCategory',
    tempItemDetails:'planner/getTempItemsDetails',
    tempPriceBand: 'planner/getTempPricebands'
  },
  priceHierarchy : "planner/priceHierarchy",
  override: "planner/override_affected_products",
  download_violation: "planner/download_violation_file",
  constraintList: 'planner/scenarioConstraints',
  exportScenario:'common/scenarioExport',
  estimatedDurationDropdown: 'planner/durationDropdown',
  categoryImpactDropdown : 'planner/categoryImpactDropdown',
  l1Category: 'planner/getCategoryLvl1',
  l2Category: 'planner/getCategoryLvl2',
  subCategory:'planner/getSubCategory',
  ItemDetails:'planner/getItemsDetails',
  scenarioFilters: 'planner/getScenarioFilters'
}

export const scenario_comparison = {
  getPlanningCycleList: 'planner/compare/scenarioList',
  getCycleScenarioList: 'planner/compare/innerScenarioList',
  getPlanningCycleCount: 'planner/compare/count',
  getScenarioComparisonResult: 'planner/compare/result',
  getScenarioComparisonTableData: 'planner/compare/scenarioInnerList'
}

export const recommendation = {
  getScenarios: "finalRecommendation/finalRecommenderScenarios",
  approversList: 'finalRecommendation/approvedScenarios',
  in_review_list: 'finalRecommendation/reviewScenarios',
  status_list: 'finalRecommendation/status',
  finalRecommendationListHeaders: 'finalRecommendation/info',
  finalRecommendationPriceTierTable: 'finalRecommendation/priceTiers',
  estimatedImpact: 'finalRecommendation/estimatedImpact',
  estimatedImpactPriceBand: 'finalRecommendation/estimatedImpactPriceBand',
  originalImpact: 'finalRecommendation/originalImpact',
  originalImpactPriceBand: 'finalRecommendation/originalImpactPriceBand',
  skuDetails: 'finalRecommendation/skuDetails',
  skuCategoryDetails: 'finalRecommendation/categoryDropdown',
  skuPriceBandDetails: 'finalRecommendation/priceBandDropdown',
  skuProductNameDetails: 'finalRecommendation/itemDropdown',
  skuDetailsCount: 'finalRecommendation/skuDetailsCount',
  graphData: 'finalRecommendation/estimatedImpactGraph',
  graphDropdownData: 'planner/getMetricsDropdown',
  approvers: 'finalRecommendation/approvers',
  rangingSummaryGraph: 'finalRecommendation/ranging-summary-graph',
  rangingSummaryTable: 'finalRecommendation/ranging-summary-table',
  productsDisplayDropdown: 'finalRecommendation/products-display-dropdown',
  moveToPast: 'finalRecommendation/moveToPast',
  moveToInMarket: 'finalRecommendation/moveToInMarket',
  priceRangingPriceBandDropdown: 'finalRecommendation/priceBandLevelDropdown',
  exportScenario:'finalRecommendation/scenarioExport',
}

export const price_recommender = {
  getScenarios: "priceRecommender/scenarios",
  approversList: 'priceRecommender/users',
  statusList: 'priceRecommender/status',
  constraintList: 'priceRecommender/scenarioConstraints',
  priceRecommenderListHeaders: 'priceRecommender/info',
  priceRecommenderPriceTierTable: 'priceRecommender/priceTiers',
  estimatedImpact: 'priceRecommender/estimatedImpact',
  estimatedImpactPriceBand: 'priceRecommender/estimatedImpactPriceBand',
  originalImpact: 'priceRecommender/originalImpact',
  originalImpactPriceBand: 'priceRecommender/originalImpactPriceBand',
  skuDetails: 'priceRecommender/skuDetails',
  skuDetailsCount: 'priceRecommender/skuDetailsCount',
  recommenderCaterogyList: 'priceRecommender/category',
  recommenderSKUList: 'priceRecommender/items',
  constraintsGetData: 'priceRecommender/constraints',
  constraintsDrillDown: 'priceRecommender/constraintLevelDetails',
  downloadPriceRecommender: 'priceRecommender/download',
  initiateNewPriceRecommender: 'priceRecommender/requestID',
  generateOptimizerInRecommenderList: 'priceRecommender/generateScenario',
  uploadPriceRecommender: "priceRecommender/upload",
  downloadConstraintRules: "priceRecommender/downloadFiles",
  businessObjective: "priceRecommender/businessObjective",
  validateOptimiser: 'priceRecommender/validateOptimizerRun'
}

export const competitor_pricing = {
  costaStoreDropdown: "competitorPricing/costaStoreDropdown",
  costaStore: "competitorPricing/costaStore",
  competitorStoreDropdown: "competitorPricing/competitorStoreDropdown",
  competitorStore: "competitorPricing/competitorStores",
  costaStoreItemDropdown: "competitorPricing/itemDropdown",
  result: "competitorPricing/result"
}

export const price_performance = {
  margin_trends_price_band_dropdown: "pricePerformance/priceBandDropdown",
  margin_trends_graph: "pricePerformance/marginTrends",
  price_trends_price_band_dropdown: "pricePerformance/priceBandDropdown",
  price_trends_products_dropdown: "pricePerformance/productsDropdown",
  price_trends_graph: "pricePerformance/priceTrends",
  metric_trends_metric_dropdown: "pricePerformance/metricDropdown",
  metric_trends_graph: "pricePerformance/metricTrends",
  price_band_analysis_scenarios: "pricePerformance/scenarios",
  price_band_analysis_hierarchy: "pricePerformance/priceBandHierarchy",
  price_band_analysis_segmentation: "pricePerformance/priceBandSegmentation",
  price_band_analysis_metrics: "pricePerformance/priceBandMetrics",
  price_band_analysis_export: "pricePerformance/scenarioReports",
  price_trends_metric_trends_export: "pricePerformance/actualsReports",
  estimated_v_actual: "pricePerformance/estimatedVsActuals",
  periodDropdown: 'pricePerformance/getPeriodDropdown',
  tableRowDropdown: 'pricePerformance/getTableRowDropdown',
  tableMetricDropdown: 'pricePerformance/getTableMetricsDropdown',
  graphMetricDropdown: 'pricePerformance/getGraphMetricsDropdown',
  est_vs_act_dropdown: 'pricePerformance/getestVsActualsDropdown',
  get_est_vs_act_graph: 'pricePerformance/getEstVsActualsGraph'
}

export const price_band_config = {
  get_price_band_config_data :"dynamicPriceBand/activePriceBands",
  get_dropdown_data : "dynamicPriceBand/activeElasticityPriceBands",
  save_price_band_config_data: "dynamicPriceBand/saveElasticityMapping",
  check_price_recommendation : "dynamicPriceBand/checkInitiatePriceRecommendation",
  view_price_band_config : "planner/getPriceBandMappingInformation"
}
